import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[amwager3DecimalInput]',
  standalone: true
})
export class DecimalInputDirective {

  @HostListener('keydown', ['$event']) onKeyDown(event: KeyboardEvent) {
    const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Delete', 'Tab'];
    if (allowedKeys.includes(event.key)) {
      return;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const currentInput: string = (event.currentTarget as any).value;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const caretPos: number = (event.currentTarget as any).selectionStart;
    const dotPos: number = currentInput.indexOf('.');

    if (
      (event.key === '.' && dotPos !== -1) ||
      (dotPos !== -1 && caretPos > dotPos && currentInput.length - dotPos > 2)
    ) {
      event.preventDefault();
      return;
    }

    if (isNaN(parseInt(event.key)) && event.key !== '.') {
      event.preventDefault();
      return;
    }
  }

}
